import React from 'react';
import { motion } from 'framer-motion';

const Stars = () => {
  // Generar estrellas aleatorias
  const stars = Array.from({ length: 100 }).map((_, i) => ({
    id: i,
    size: Math.random() * 2 + 1,
    left: `${Math.random() * 100}%`,
    top: `${Math.random() * 100}%`,
    delay: Math.random() * 3
  }));

  return (
    <div className="absolute inset-0">
      {stars.map(star => (
        <motion.div
          key={star.id}
          animate={{
            opacity: [0.2, 1, 0.2]
          }}
          transition={{
            duration: 3,
            delay: star.delay,
            repeat: Infinity,
            repeatType: "reverse"
          }}
          className="absolute rounded-full bg-white"
          style={{
            width: star.size,
            height: star.size,
            left: star.left,
            top: star.top
          }}
        />
      ))}
    </div>
  );
};

export default Stars; 